import { Outlet } from 'react-router-dom'
import TopNav from './TopNav'

export default function AppShell() {
  return (
    <div className="min-h-screen flex flex-col bg-hoop-bg">
      <TopNav />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
